import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { List } from "immutable";
import { getDrupalVacancies } from "../../custom_api/api";
import { Teaser } from "./teaser";
import { slugify } from "../../custom_utils/helpers";
export class VacancyOverviewBlock extends React.Component {
    async componentDidMount() {
        const categoryId = this.props.category_id;
        if (categoryId === null) {
            this.setState((s)=>({
                    ...s,
                    vacancies: List()
                }));
            return;
        }
        let vacanciesData = await getDrupalVacancies(List([
            categoryId
        ]));
        if (vacanciesData !== "error") {
            this.setState((s)=>({
                    ...s,
                    vacancies: List(vacanciesData)
                }));
        }
    }
    render() {
        let p = this.props;
        let s = this.state;
        const placeholderText = p.placeholder ?? "Op dit moment zijn er helaas geen vacatures beschikbaar. Maar dat wil niet zeggen dat jij niets voor de bibliotheek kunt betekenen. Stuur ons dus vooral jouw contactgegevens en cv. Wellicht hebben we binnenkort wél een geschikte vacature!";
        return /*#__PURE__*/ _jsxs("section", {
            className: "block block--content-grid block--vacancies richtext-block",
            children: [
                (p.title || p.html) && /*#__PURE__*/ _jsxs("header", {
                    className: "block__header",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            "data-anchor": slugify(p.title),
                            className: "block__title title--l",
                            children: p.title
                        }),
                        p.html && /*#__PURE__*/ _jsx("div", {
                            dangerouslySetInnerHTML: {
                                __html: p.html
                            },
                            className: "block__intro"
                        })
                    ]
                }),
                s.vacancies !== 'error' && s.vacancies !== 'loading' && (!s.vacancies.isEmpty() ? /*#__PURE__*/ _jsx(_Fragment, {
                    children: /*#__PURE__*/ _jsx("ul", {
                        className: "teasers row",
                        children: s.vacancies.map((v, i)=>/*#__PURE__*/ _jsx(Teaser, {
                                extraClasses: "vacancy col-xs-12 col-sm-6",
                                linkUrl: v.url,
                                headingLevel: "h3",
                                title: v.title,
                                intro: v.subtitle,
                                footer: v.locations.split(',').length == 1 ? v.locations : "Meerdere locaties",
                                row_count: p.row_count
                            }, `vacancy_overview_${i}`))
                    })
                }) : /*#__PURE__*/ _jsx("p", {
                    className: "weight--bold",
                    children: placeholderText
                }))
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            vacancies: "loading"
        };
    }
}
